import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeApiResponse  {
    _originalTypeClassName = "zSHR.BO.EmployeeApiResponse";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeApiResponse.translate = translateService;
}
this.StatusText = null;
this.EmployeeApiResponseKey = null;
this._key = this.EmployeeApiResponseKey = 0; 
}

static translate: TranslateService;
_key: any;
StatusText:any;
Employee:any;
private _EmployeeApiResponseKey:any;
get EmployeeApiResponseKey(): any {
    return this._EmployeeApiResponseKey;
  }
set EmployeeApiResponseKey(value: any) {
    this._EmployeeApiResponseKey = value;
    this._key = value;
  }
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmployeeApiResponseKey == null || $this.EmployeeApiResponseKey == 0;
            }


}